import Cta from '@/components/storefront/Cta'
import { money } from '@/lib/money'

/**
 * Fixed bottom bar for phones: the total is always in view and the action is
 * one thumb away. Never disabled - tapping it runs the same validate-and-
 * scroll handler as the summary button, so an incomplete checkout explains
 * itself instead of presenting a dead button. Hidden from lg: up, where the
 * sticky summary column is visible beside the sections.
 */
export default function MobileCheckoutBar({
  total,
  label,
  loading,
  onSubmit,
}: {
  total: number
  label: string
  loading: boolean
  onSubmit: () => void
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-foreground/10 bg-background/95 backdrop-blur lg:hidden">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
        <div>
          <p className="text-2xs font-bold uppercase tracking-wide text-foreground/50">Total</p>
          <p className="text-lg font-extrabold text-primary">{money(total)}</p>
        </div>
        <Cta size="md" arrow loading={loading} onClick={onSubmit}>
          {label}
        </Cta>
      </div>
    </div>
  )
}
